import { Subscription } from 'rxjs';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core'
import * as moment from 'moment'
import { getImageRedirectUrl } from '../../../../../../helper/common'
import { MatrixServices } from '../../../../../services/image/matrix.services'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { StateServices } from '../../../../../services/state.services'
import { ClientTopServices } from '../../../../../services/ClientTop.services'
import { DatepickerHelper } from '../../../../../../helper/datepicker.helper'
import { SharedServices } from '../../../../../services/shared.services'

@Component({
    selector: 'app-render-form-settings',
    templateUrl: './render-form-settings.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        './render-form-settings.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class RenderFormSettingsComponent implements OnInit, OnDestroy, OnChanges {

    initData2General: any[] = []
    // listOption2General: any[] = [];
    // jsonDataSave: any = {};
    arrImage: any[] = []
    arrImageHash: any[]
    optionsStartDate: any = { viewMode: 'days', ...DatepickerHelper.BASE_OPTIONS }
    arrayDate: any[] = []
    arrayLoadImage: any[] = []
    animationDuration: any = 2800
    arrayMatrixImage: any[] = []

    hashCallService: any

    jsonDateShow: any = {}
    isFirstLoading: Boolean = false
    getFirst
    optionsBirthday: any = {
        viewMode: 'years',
        ...DatepickerHelper.BASE_NONE_TODAY_OPTIONS,
    }

    // Task 485
    cacheOldValue = {}
    lang: any = {}
    alignerStr: string = 'aligner'
    changeLangguage: Subscription

    @Input() listOption2General: any[] = []
    @Input() jsonDataSave: any = {}
    @Input() jsonChangeSave: any = {}
    @Input() tabsRender: any = ''
    @Input() parentComponent: string = null

    @Output() emitJsonSave: EventEmitter<any> = new EventEmitter<any>()

    constructor(
        public matrixServices: MatrixServices,
        private authData: AuthService,
        private restApi: RestServices,
        private stateServices: StateServices,
        private clientTopServices: ClientTopServices,
        private sharedServices: SharedServices,
    ) {
    }

    ngOnInit() {
        // this.callService();
        this.getArrHash()
        this.stateServices.emitChangeTabName('formSetting')
        // this.callInitMatrix();
        this.getFirstLoading()
        this.changLanguage()
    }

    ngOnChanges(changes: SimpleChanges) {
        this.isFirstLoading = false
        // this.jsonDataSave = undefined;
        // this.listOption2General = [];
        if (changes['listOption2General'] && changes['listOption2General']['currentValue']) {
            if (this.matrixServices.arrFlip.length < this.listOption2General.length) {
                this.arrImage = []
                this.arrImageHash = []
                this.initArrMatrix(this.listOption2General)
            }
        }
    }

    /**
     * Listen when have change language event trigger.
     * If there is not default language, it will display japaness
     */
    changLanguage() {
        let defaultLang = localStorage.getItem('lang') || false
        this.lang = this.authData.showLang(defaultLang)
        this.changeLangguage = this.sharedServices.changeEmittedChangeLanguage$.subscribe(lang => {
            this.lang = this.authData.showLang(false)
        })
    }

    callInitMatrix() {
        if (this.listOption2General.length > 0) {
            if (this.matrixServices.arrFlip.length < this.listOption2General.length) {
                this.initArrMatrix(this.listOption2General)
            }
        } else {
            setTimeout(() => {
                this.callInitMatrix()
            }, 200)
        }
    }

    ngOnDestroy() {
        this.isFirstLoading = false
        if (this.hashCallService)
            this.hashCallService.unsubscribe()
        if (this.getFirst)
            this.getFirst.unsubscribe()

        if (this.changeLangguage) {
            this.changeLangguage.unsubscribe()
        }
    }

    getFirstLoading() {
        this.getFirst = this.stateServices.changeEmittedFirstLoading$.subscribe(res => {
            if (res) {
                this.isFirstLoading = res['first']
                this.jsonDateShow = {}
                this.arrayDate = []
                this.listOption2General.forEach((el, i) => {
                    if (el && el['schema'] && el['schema']['type'] == 'date') {
                        if (el['schema']['uiOptions'] && el['schema']['uiOptions']['behavior'] == 'recentToday') {
                            if (this.jsonDataSave[el['propertyName']]) {
                                if (typeof this.jsonDataSave[el['propertyName']] == 'number') {
                                    this.arrayDate[i] = moment(this.jsonDataSave[el['propertyName']])
                                }
                            } else {
                                this.arrayDate[i] = moment(moment().valueOf())
                            }
                        } else {
                            if (this.jsonDataSave[el['propertyName']] && typeof this.jsonDataSave[el['propertyName']] == 'number') {
                                this.arrayDate[i] = moment(this.jsonDataSave[el['propertyName']])
                            }
                        }
                    }
                })

                this.arrImageHash = []
                this.arrImage = []
                this.arrayMatrixImage = []
            }
        })
    }

    showBigImage(id, matrix) {
        const emitArr: any = {}
        emitArr['id'] = id
        emitArr['showBigImage'] = true
        emitArr['matrix'] = matrix
        this.clientTopServices.emitChange(emitArr)
    }

    functionEmitJsonSave() {
        this.emitJsonSave.emit(this.jsonChangeSave)
    }

    defaultRotate(event, propertyName, ratate, i) {
        event.preventDefault()
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        if (!this.matrixServices.arrFlip[i]) {
            // this.matrixServices.arrImageHash = this.arrImageHash;
            this.matrixServices.arrRotate[i] = 0
            this.matrixServices.arrStyleImage[i] = ''
            this.matrixServices.arrFlip[i] = jsonFlip
            this.matrixServices.dXdYMatrixCanvas[i] = 0
        }

        this.stateServices.emitChangeRatatepropertyName(propertyName)

        // console.log(i);
        // console.log(this.matrixServices.arrImageHash);
        // console.log(this.matrixServices.matrixImage);
        // this.ratatepropertyName = propertyName;
        // const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + i);
        // const imageId: HTMLElement = document.getElementById('imageId' + i);
        // this.matrixServices.defaultRotate(i, this.matrixServices.arrRotate[i], imageId, imageWrapper, ratate, this.matrixServices.arrFlip[i]['horizontalFlip'], this.matrixServices.arrFlip[i]['verticalFlip']);
    }

    getArrHash() {
        this.hashCallService = this.stateServices.changeEmittedHash$.subscribe(response => {
            const tabs = this.stateServices.returnViewAligner()
            const ratatepropertyName = this.stateServices.returnRatatepropertyName()
            if (response && response['formSetting'] && ratatepropertyName && ratatepropertyName != '' && tabs == 'renderData') {
                const index = response['index']
                const data: any[] = response['formSetting']
                const jsonChangeMatrix = jQuery.extend(true, {}, data[index])

                this.jsonDataSave[ratatepropertyName] = jsonChangeMatrix
                this.jsonChangeSave[ratatepropertyName] = jsonChangeMatrix
                this.emitJsonSaveFormSetting()
                this.stateServices.emitChangeRatatepropertyName(null)
            }
        })
    }

    emitJsonSaveFormSetting() {
        // const jsonSave = {};
        // jsonSave['jsonDataSave'] = this.jsonDataSave;
        // this.stateServices.emitChangeJsonSaveFormSetting(jsonSave);
        this.functionEmitJsonSave()
    }

    callService() {
        this.stateServices.changeEmittedArrayFormSetting$.subscribe(res => {
            if (res && res['data']) {
                this.listOption2General = res['data']
                this.jsonDataSave = res['jsonDataSave']
                if (this.matrixServices.arrFlip.length < this.listOption2General.length) {
                    this.initArrMatrix(this.listOption2General)
                }
            }
        })
    }

    getDateToday(datetime = new Date()) {
        const offsetTimezone = new Date().getTimezoneOffset()
        const addTime = 24 + (offsetTimezone / 60)
        if (datetime) {
            if (moment(datetime).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                return moment().format('YYYY.MM.DD ddd')
            } else {
                // moment(datetime).startOf('day').add(addTime, 'hours').format('YYYY.MM.DD ddd');
                return moment(datetime).startOf('day').add(addTime, 'hours').format('YYYY.MM.DD ddd')
            }
        } else {
            return moment().format('YYYY.MM.DD ddd')
        }
    }

    initArrAllData2General(arr2Gen: any[] = []) {
        this.initData2General = []
        const jsonAdd: any = {}
        if (arr2Gen && arr2Gen.length > 0) {
            arr2Gen.forEach((el, i) => {
                if (el['schema'] && el['schema']['type'] == 'date') {
                    jsonAdd[el['propertyName']] = ''
                } else if (el['schema'] && el['schema']['type'] == 'object' && el['schema']['uiType'] == 'image') {
                    jsonAdd[el['propertyName']] = {
                        'id': '',
                        'matrix': [1, 0, 0, 1],
                    }
                } else if (el['schema']['uiType'] == 'button') {
                    if (el['isListField']) {
                        jsonAdd[el['propertyName']] = []
                    } else {
                        jsonAdd[el['propertyName']] = ''
                    }
                } else if (el['schema']['uiConditionType'] == 'partial') {
                    jsonAdd[el['propertyName']] = ''
                } else {
                    jsonAdd[el['propertyName']] = ''
                }
            })
        }
        return jsonAdd
    }

    getClassHide(title) {
        if (title && title != '') {
            return false
        }
        return true
    }

    changeOptionSchema(propertyName, optionsId, arrFirst) {
        const findData = this.listOption2General.find(el => {
            return el['propertyName'] == propertyName
        })
        if (findData['schema'] && findData['schema']['uiType'] == 'button' && findData['schema']['type'] == 'array') {
            let tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            if (typeof tmpData == 'object') {
                if (Array.isArray(tmpData)) {
                    const check = tmpData.indexOf(optionsId)
                    if (check == -1) {
                        tmpData.push(optionsId)
                    } else {
                        const findIndex = tmpData.findIndex(el => {
                            return el == optionsId
                        })
                        if (findIndex != -1) {
                            tmpData.splice(findIndex, 1)
                        }
                    }
                } else {
                    const tmpDataChange = []
                    tmpDataChange.push(optionsId)
                    tmpData = jQuery.extend(true, [], tmpDataChange)
                }
            } else if (typeof tmpData == 'number') {
                const tmpDataChange = []
                tmpDataChange.push(optionsId)
                tmpData = jQuery.extend(true, [], tmpDataChange)
            } else {
                const tmpDataChange = []
                tmpDataChange.push(tmpData)
                tmpDataChange.push(optionsId)
                tmpData = jQuery.extend(true, [], tmpDataChange)
            }
            const newArrMultiSelect: any[] = []
            arrFirst.forEach(element => {
                if (tmpData.indexOf(element['_id']) != -1) {
                    newArrMultiSelect.push(element['_id'])
                }
            })
            this.jsonDataSave[propertyName] = newArrMultiSelect
            this.jsonChangeSave[propertyName] = newArrMultiSelect
        } else if (findData['schema'] && findData['schema']['uiType'] == 'dialog' || findData['schema'] && findData['schema']['type'] == 'array' && findData['schema']['uiType'] != 'button') {
            let tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            if (typeof tmpData == 'object') {
                if (Array.isArray(tmpData)) {
                    const check = tmpData.indexOf(optionsId)
                    if (check == -1) {
                        tmpData.push(optionsId)
                    } else {
                        const findIndex = tmpData.findIndex(el => {
                            return el == optionsId
                        })
                        if (findIndex != -1) {
                            tmpData.splice(findIndex, 1)
                        }
                    }
                } else {
                    const tmpDataChange = []
                    tmpDataChange.push(optionsId)
                    tmpData = jQuery.extend(true, [], tmpDataChange)
                }
            } else if (typeof tmpData == 'number') {
                const tmpDataChange = []
                tmpDataChange.push(optionsId)
                tmpData = jQuery.extend(true, [], tmpDataChange)
            } else {
                const tmpDataChange = []
                tmpDataChange.push(tmpData)
                tmpDataChange.push(optionsId)
                tmpData = jQuery.extend(true, [], tmpDataChange)
            }
            const newArrMultiSelect: any[] = []
            arrFirst.forEach(element => {
                if (tmpData.indexOf(element['_id']) != -1) {
                    newArrMultiSelect.push(element['_id'])
                }
            })
            this.jsonDataSave[propertyName] = newArrMultiSelect
            this.jsonChangeSave[propertyName] = newArrMultiSelect
        } else {
            if (this.jsonDataSave[propertyName] && this.jsonDataSave[propertyName] == optionsId) {
                this.jsonDataSave[propertyName] = ''
                this.jsonChangeSave[propertyName] = ''
            } else {
                this.jsonDataSave[propertyName] = optionsId
                this.jsonChangeSave[propertyName] = optionsId
            }
        }
        this.emitJsonSaveFormSetting()
    }

    checkDatepickerLoading() {
        this.isFirstLoading = true
    }

    updateDatepicker(event, propertyName, index) {
        if (event) {
            const offsetTimezone = new Date().getTimezoneOffset()
            const addTime = 24 + (offsetTimezone / 60)
            if (this.isFirstLoading) {
                const timestamp = moment(event['_d'])
                timestamp.set({ hours: 10 })
                if (moment(timestamp).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
                    this.jsonChangeSave[propertyName] = moment().utc().startOf('day').valueOf()
                } else {
                    this.jsonDataSave[propertyName] = moment(timestamp).utc().startOf('day').valueOf()
                    this.jsonChangeSave[propertyName] = moment(timestamp).utc().startOf('day').valueOf()
                }
                this.cacheOldValue[propertyName] = this.jsonDataSave[propertyName]
                this.isFirstLoading = false
                this.emitJsonSaveFormSetting()
            }
        }
    }

    onChangInputValue(event, propertyName) {
        this.jsonDataSave[propertyName] = event.target.value
        this.jsonChangeSave[propertyName] = event.target.value
        this.emitJsonSaveFormSetting()
    }

    prevDate(propertyName, number, index) {
        // const offsetTimezone = new Date().getTimezoneOffset();
        // const addTime = 24 + (offsetTimezone / 60);
        if (this.jsonDataSave[propertyName]) {
            const adDate = moment(this.jsonDataSave[propertyName])
            const timestampDate = moment(adDate['_d']).subtract(number, 'days').utc().startOf('day').valueOf()
            // const initDate = new Date(this.jsonDataSave[propertyName]);
            // const subDate = new Date(initDate.setDate(initDate.getDate() - number));
            if (moment(timestampDate).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
                this.jsonChangeSave[propertyName] = moment().utc().startOf('day').valueOf()
                // this.jsonDateShow[propertyName] = moment().utc().valueOf();
            } else {
                this.jsonChangeSave[propertyName] = moment(timestampDate).utc().startOf('day').valueOf()
                this.jsonDataSave[propertyName] = moment(timestampDate).utc().startOf('day').valueOf()

                // this.jsonDateShow[propertyName] = moment(subDate).utc().valueOf();
            }
            this.arrayDate[index] = moment(moment(this.jsonDataSave[propertyName]).valueOf())
            this.emitJsonSaveFormSetting()
        }
    }

    nextDate(propertyName, number, index) {
        if (this.jsonDataSave[propertyName]) {
            const adDate = moment(this.jsonDataSave[propertyName])
            const timestampDate = moment(adDate['_d']).add(number, 'days').utc().startOf('day').valueOf()
            if (moment(timestampDate).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                this.jsonChangeSave[propertyName] = moment().utc().startOf('day').valueOf()
                this.jsonDataSave[propertyName] = moment().utc().startOf('day').valueOf()
                // this.jsonDateShow[propertyName] = moment().utc().valueOf();
            } else {
                this.jsonChangeSave[propertyName] = moment(timestampDate).utc().startOf('day').valueOf()
                this.jsonDataSave[propertyName] = moment(timestampDate).utc().startOf('day').valueOf()
                // this.jsonDateShow[propertyName] = moment(subDate).utc().valueOf();
            }
            this.arrayDate[index] = moment(moment(this.jsonDataSave[propertyName]).valueOf())
            this.emitJsonSaveFormSetting()
        }
    }

    getUrlImage(propertyName, index) {
        if (this.jsonDataSave[propertyName]) {
            const url = getImageRedirectUrl(this.jsonDataSave[propertyName]['id'] + '?type=medium')
            this.arrImage[index] = url
            this.arrImageHash[index] = jQuery.extend(true, {}, this.jsonDataSave[propertyName])
            this.arrayMatrixImage[index] = jQuery.extend(true, [], this.jsonDataSave[propertyName]['matrix'])
            const matrix = this.jsonDataSave[propertyName]['matrix']
            if (!this.matrixServices.arrImageHash[index]) {
                this.matrixServices.arrImageHash[index] = jQuery.extend(true, {}, this.jsonDataSave[propertyName])
                this.matrixServices.matrixImage[index] = jQuery.extend(true, [], this.jsonDataSave[propertyName]['matrix'])
            }
            this.arrayMatrixImage[index] = matrix
            const emitHash = {}
            emitHash['hashJson'] = this.arrImageHash
            emitHash['hashLink'] = this.arrImage
            emitHash['hashMatrix'] = this.arrayMatrixImage
            this.stateServices.emitChangeArrImageHash(emitHash)
            return url
        }
        return ''
    }

    allowDrop(e) {
        e.preventDefault()
    }

    drop(e, propertyName, index) {
        e.preventDefault()
        if (this.matrixServices.arrFlip.length < this.listOption2General.length) {
            this.initArrMatrix(this.listOption2General)
        }
        const reader = new FileReader()
        reader.readAsDataURL(e.dataTransfer.files[0])
        const excrptFile: any = 'image/'
        const tmpFile: any = e.dataTransfer.files[0]
        const typeFile: String = tmpFile['type']
        this.animationDuration = 3500
        if (typeFile.includes(excrptFile) && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            reader.onload = (event: any) => {
                this.arrayLoadImage[index] = true
            }
            const fileData = e.dataTransfer.files.item(0)
            this.authData.authToken().then(tokenReNew => {
                this.restApi.postFile(fileData, tokenReNew).subscribe(
                    success => {
                        const jsonImage = {}
                        jsonImage['id'] = success['hash']
                        jsonImage['matrix'] = [1, 0, 0, 1]
                        this.jsonDataSave[propertyName] = jsonImage
                        this.jsonChangeSave[propertyName] = jsonImage
                        this.arrayMatrixImage[index] = [1, 0, 0, 1]
                        this.arrImageHash[index] = jsonImage
                        const url = getImageRedirectUrl(success['hash'] + '?type=medium')
                        this.arrImage[index] = url
                        const emitHash = {}
                        emitHash['hashJson'] = this.arrImageHash
                        emitHash['hashLink'] = this.arrImage
                        emitHash['hashMatrix'] = this.arrayMatrixImage
                        this.stateServices.emitChangeArrImageHash(emitHash)
                        this.emitJsonSaveFormSetting()
                        this.arrayLoadImage[index] = false
                    },
                )
            })
        }
    }

    handleFileInput(files: FileList, propertyName, event, index) {
        if (event.target.files && event.target.files[0]) {
            if (this.matrixServices.arrFlip.length < this.listOption2General.length) {
                this.initArrMatrix(this.listOption2General)
            }
            this.arrayLoadImage[index] = true
            // this.tabUploadImage = this.TabRegistrationFaceClass;
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            const excrptFile: any = 'image/'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                // this.animationDuration = 2800;
                // this.arrLoading[ind] = true;
                reader.onload = (event: any) => {
                    // this.getUrlImage(this.index, event.target.result);
                    // this.url = event.target.result;
                    // this.arrShowStatus[ind] = true;
                }
                // const arrUploadImage: any[] = this.arrRegistrationFace;
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            const jsonImage = {}
                            jsonImage['id'] = success['hash']
                            jsonImage['matrix'] = [1, 0, 0, 1]
                            this.jsonDataSave[propertyName] = jsonImage
                            this.jsonChangeSave[propertyName] = jsonImage
                            this.arrayMatrixImage[index] = [1, 0, 0, 1]
                            this.arrImageHash[index] = jsonImage
                            const url = getImageRedirectUrl(success['hash'] + '?type=medium')
                            this.arrImage[index] = url
                            const emitHash = {}
                            emitHash['hashJson'] = this.arrImageHash
                            emitHash['hashLink'] = this.arrImage
                            emitHash['hashMatrix'] = this.arrayMatrixImage
                            this.stateServices.emitChangeArrImageHash(emitHash)
                            this.emitJsonSaveFormSetting()
                            this.arrayLoadImage[index] = false
                        },
                    )
                })
            }
        }
    }

    // Task 485
    // Toggle the value of datepick. Active only on the aligner page
    onToggleValueOfDate(propertyName, index) {
        if (this.jsonDataSave[propertyName]) {
            this.cacheOldValue[propertyName] = this.jsonDataSave[propertyName]
            this.jsonChangeSave[propertyName] = null
            this.jsonDataSave[propertyName] = null
        } else {
            if (this.cacheOldValue[propertyName]) {
                let currentDate = moment(this.cacheOldValue[propertyName]).utc().startOf('day').valueOf()
                this.jsonChangeSave[propertyName] = currentDate
                this.jsonDataSave[propertyName] = currentDate
                this.cacheOldValue[propertyName] = null

            }
        }
    }

    getShowDate(propertyName, index) {
        const findData = this.listOption2General.find(el => {
            return el['propertyName'] == propertyName
        })
        let showDate = 'Click to Select'
        if (this.jsonDataSave[propertyName]) {
            if (typeof this.jsonDataSave[propertyName] == 'number') {
                showDate = this.getDateToday(this.jsonDataSave[propertyName])
            } else {
                if (findData && findData['schema'] && findData['schema']['uiOptions'] && findData['schema']['uiOptions']['behavior'] && findData['schema']['uiOptions']['behavior'] == 'recentToday') {
                    if (this.parentComponent === this.alignerStr) {
                        if (this.cacheOldValue['propertyName']) {
                            showDate = this.setDefaultValue(propertyName, showDate, index)
                        }
                    } else {
                        showDate = this.setDefaultValue(propertyName, showDate, index)
                    }
                }
            }
        } else if (findData && findData['schema'] && findData['schema']['uiOptions'] && findData['schema']['uiOptions']['behavior'] && findData['schema']['uiOptions']['behavior'] == 'recentToday') {
            if (this.parentComponent === this.alignerStr) {
                if (this.cacheOldValue['propertyName']) {
                    showDate = this.setDefaultValue(propertyName, showDate, index)
                }
            } else {
                showDate = this.setDefaultValue(propertyName, showDate, index)
            }
            this.emitJsonSaveFormSetting()
        }
        return showDate
    }

    setDefaultValue(propertyName, showDate, index): string {
        let currentDate = moment().utc().startOf('day').valueOf()
        this.jsonChangeSave[propertyName] = currentDate
        this.jsonDataSave[propertyName] = currentDate
        showDate = this.getDateToday()
        const _thi = this
        setTimeout(() => {
            _thi.arrayDate[index] = moment(moment().valueOf())
        }, 100)

        return showDate
    }

    getClassBtn(propertyName, optionsId) {
        const findData = this.listOption2General.find(el => {
            return el['propertyName'] == propertyName
        })
        if (findData && findData['schema'] && findData['schema']['uiType'] == 'button') {
            const tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            if (typeof tmpData == 'object') {
                if (Array.isArray(tmpData)) {
                    if (tmpData && tmpData.length != 0) {
                        const check = tmpData.indexOf(optionsId)
                        if (check != -1) {
                            return true
                        }
                    }
                }
            } else {
                if (this.jsonDataSave[propertyName] == optionsId) {
                    return true
                }
            }
        } else if (findData && findData['schema'] && findData['schema']['uiType'] == 'dialog') {
            const tmpData: any[] = this.jsonDataSave[propertyName] ? this.jsonDataSave[propertyName] : []
            if (Array.isArray(tmpData)) {
                const check = tmpData.indexOf(optionsId)
                if (check != -1) {
                    return true
                }
            }
        } else {
            if (this.jsonDataSave[propertyName]) {
                if (this.jsonDataSave[propertyName] == optionsId) {
                    return true
                }
            }
        }
        return false
    }

    getValueGeneral(propertyName) {
        if (this.jsonDataSave[propertyName]) {
            if (typeof this.jsonDataSave[propertyName] == 'object' || typeof this.jsonDataSave[propertyName] == 'number') {
                this.jsonDataSave[propertyName] = ''
                this.jsonChangeSave[propertyName] = ''
                return ''
            } else {
                return this.jsonDataSave[propertyName]
            }
        }
        return ''
    }

    getShowItem(item: any = {}) {
        if (Object.keys(item).length > 0) {
            return true
        }
        return false
    }

    initArrMatrix(arrayGeneral: any[] = []) {
        const hash = this.stateServices.returnArrImageHash()
        this.arrImage = []
        this.arrImageHash = []
        this.arrayMatrixImage = []
        const matrix = [1, 0, 0, 1]
        this.arrayLoadImage = []
        let arrRotate: any[]
        let arrStyleImage: any
        let arrFlip: any[]
        let dxdyMatrix: any[]
        let tpmArrImageHash: any[] = []
        let tmpArrImage: any[] = []
        let tmpArrayMatrixImage: any[] = []
        if (this.tabsRender == 'header') {
            arrRotate = []
            arrStyleImage = []
            arrFlip = []
            tmpArrImage = []
            tpmArrImageHash = []
            tmpArrayMatrixImage = []
            dxdyMatrix = []
            this.arrImage = []
            this.arrImageHash = []
        } else {
            tmpArrImage = hash && hash['hashLink'] ? hash['hashLink'] : []
            tpmArrImageHash = hash && hash['hashJson'] ? hash['hashJson'] : []
            tmpArrayMatrixImage = hash && hash['hashMatrix'] ? hash['hashMatrix'] : []
            arrRotate = this.matrixServices.arrRotate
            arrStyleImage = this.matrixServices.arrStyleImage
            arrFlip = this.matrixServices.arrFlip
            dxdyMatrix = this.matrixServices.dXdYMatrixCanvas
        }
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        // const arrLoadingMatrix: any[] = [];
        // const url = getImageRedirectUrl(success['hash'];
        if (arrayGeneral && arrayGeneral.length > 0) {
            arrayGeneral.forEach((el, i) => {
                if (el && Object.keys(el).length > 0) {
                    if (this.jsonDataSave[el['propertyName']]) {
                        if (typeof this.jsonDataSave[el['propertyName']] == 'object' && !Array.isArray(this.jsonDataSave[el['propertyName']])) {
                            const url = getImageRedirectUrl(this.jsonDataSave[el['propertyName']]['id'] + '?type=medium')
                            tmpArrImage.push(url)
                            tpmArrImageHash.push(this.jsonDataSave[el['propertyName']])
                            const tmpMatrix = this.jsonDataSave[el['propertyName']]['matrix']
                            tmpArrayMatrixImage.push(tmpMatrix)
                        } else {
                            tpmArrImageHash.push({})
                            tmpArrImage.push('')
                            tmpArrayMatrixImage.push(matrix)
                        }
                    } else {
                        tpmArrImageHash.push({})
                        tmpArrImage.push('')
                        tmpArrayMatrixImage.push(matrix)
                    }
                    arrRotate.push(0)
                    arrStyleImage.push('')
                    arrFlip.push(jsonFlip)
                    dxdyMatrix.push(0)
                    this.arrayLoadImage.push(false)
                    if (el['schema'] && el['schema']['type'] == 'date') {
                        if (el['schema']['uiOptions'] && el['schema']['uiOptions']['behavior'] == 'recentToday') {
                            if (this.jsonDataSave[el['propertyName']]) {
                                if (typeof this.jsonDataSave[el['propertyName']] == 'number') {
                                    this.arrayDate[i] = moment(this.jsonDataSave[el['propertyName']])
                                }
                            } else {
                                this.arrayDate[i] = moment(moment().valueOf())
                            }
                        } else {
                            if (this.jsonDataSave[el['propertyName']] && typeof this.jsonDataSave[el['propertyName']] == 'number') {
                                this.arrayDate[i] = moment(this.jsonDataSave[el['propertyName']])
                            }
                        }
                    }
                }
                // arrLoadingMatrix.push(false);
            })
            this.arrayMatrixImage = jQuery.extend(true, [], tmpArrayMatrixImage)
            this.arrImage = jQuery.extend(true, [], tmpArrImage)
            this.arrImageHash = jQuery.extend(true, [], tpmArrImageHash)
            const tmpArrFipl: any[] = this.matrixServices.arrFlip
            if (tmpArrFipl.length < arrFlip.length) {
                this.matrixServices.arrImageHash = this.arrImageHash
                this.matrixServices.arrRotate = arrRotate
                this.matrixServices.arrStyleImage = arrStyleImage
                this.matrixServices.arrFlip = arrFlip
                this.matrixServices.dXdYMatrixCanvas = dxdyMatrix
            }
            // this.matrixServices.arrLoading = arrLoadingMatrix;
        }
    }

    onDeleteImage(propertyName, index) {
        $('#inputImage' + index).val('')
        this.arrImage[index] = ''
        this.arrImageHash[index] = {}
        this.matrixServices.removePhoto(index)
        this.jsonDataSave[propertyName] = undefined
        this.jsonChangeSave[propertyName] = ''
        this.emitJsonSaveFormSetting()
        const emitDelete = {}
        emitDelete['propertyName'] = propertyName
        this.stateServices.emitChangeDeletePropertyName(emitDelete)
    }

    checkTimeout() {
        if (this.authData.getItem('user')) {
            const user = JSON.parse(this.authData.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if (timeOut <= timeNow) {
                this.sharedServices.emitChange("timeoutFormSetting")
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/setting-behaviour/render-form-settings/render-form-settings.component.ts